import { useMemo } from 'react';
import { Breadcrumbs, DetailsPanel, Typography } from '@weareopenr/component-library';
import { IVenueCategory } from 'src/types/venue.types';
import { useVenueCategories } from 'src/hooks/useVenueCategories';
import { buildCategoryHierarchy } from 'src/helpers/buildCategoryHierarchy';
import styles from './VenueCategories.module.scss';

export interface IVenueCategoriesProps {
  categories: IVenueCategory[];
}

const VenueCategories = ({ categories }: IVenueCategoriesProps) => {
  const { orderedFlatCategories } = useVenueCategories();

  const categoryPaths = useMemo(
    () =>
      buildCategoryHierarchy(categories, orderedFlatCategories, {
        getId: (cat) => cat.categoryId,
        getParentId: (cat) => cat.parentCategoryId,
        idKey: 'category_id',
        parentIdKey: 'parent_category_id',
      }),
    [categories, orderedFlatCategories],
  );

  return (
    <DetailsPanel title="Venue Categories">
      <div className={styles['categories-list']}>
        {categoryPaths.length > 0 ? (
          categoryPaths.map((categoryPath) => (
            <Breadcrumbs key={categoryPath.id} breadcrumbs={categoryPath.breadcrumbs} />
          ))
        ) : (
          <Typography colour="primary">No venues categories associated</Typography>
        )}
      </div>
    </DetailsPanel>
  );
};

export default VenueCategories;
